<template>

<div class="nested" v-if="item.game.contains.length" :class="{'is-active': is.active}">

	<app-game-item v-for="subitem in contained" filter="collection" v-bind:key="subitem.id" :summarised="true" :condensed="true" :item="subitem" :can="can" :fields="columns">

		<div class="nested-horizontal"></div>

	</app-game-item>

	<div class="nested-vertical"></div>

</div>

</template>

<script>

export default {

	props: ['item', 'columns'],

	data: function() {

		return {
			is: {
				active: false
			},
			can: {
				rename: false,
				tag: false,
				filter: false,
				nesting: false,
				export: false,
				game: true,
				list: {
					remove: false
				},
				users: {
					remove: false
				}
			}
		}

	},

	computed: {

		contained: function() {

			var contained = []

			this.$_.each(this.item.game.contains, function(id) {

				if (id !== this.item.id) contained.push(this.$store.getters['page/' + this.$store.getters['service/select/name'] + '/contained/associated/collection'][id])

			}.bind(this))

			contained = this.$_.sortBy(contained, function(item) {

				return item.game.name

			})

			return contained

		}

	},

	created: function() {

		this.$pubsub.$on('contained.open.' + this.item.id, this.onToggle.bind(this))

	},

	beforeDestroy: function() {

		this.$pubsub.$off('contained.open.' + this.item.id, this.onToggle.bind(this))

	},

	methods: {

		onToggle: function() {

			this.is.active = !this.is.active

		}

	}

}

</script>

<style scoped>

.nested {
	padding-bottom: 3px;
	margin-top: -4px;
	display: none;
}

.nested.is-active {
	display: block;
}

.nested-horizontal {
	position: absolute;
	height: 1px;
	width: 16px;
	left: 8px;
	top: 16px;
	border-bottom: 1px dotted #ccc;
}

.nested-vertical {
	position: absolute;
	border-left: 1px dotted #ccc;
	top: -4px;
	bottom: 20px;
	left: 8px;
	width: 1px;
}

.is-mobile .nested-vertical {
	top: -28px;
	bottom: 48px;
}

</style>